export default __webpack_public_path__ + "static/icons.dark-fff2cba606ab0de45a49c06a3e26025384f6d001a0d6a2a4a2456c585a73ca04.png";